import React, { forwardRef } from 'react';
import { cn } from './cn';
import { TimeInput24, DateTimeInput24 } from './TimeInput24';

const BASE =
  'block w-full rounded-lg text-sm transition-all duration-200 bg-surface-sunken text-heading border shadow-xs placeholder:text-muted focus:outline-none disabled:cursor-not-allowed disabled:opacity-70';

const STATE = {
  default: 'border-line-strong hover:border-line-strong focus:border-brand focus:ring-1 focus:ring-brand',
  error: 'border-red-500 focus:border-red-500 focus:ring-1 focus:ring-red-500',
  success: 'border-emerald-500 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500',
};

/**
 * Input — ô nhập text. state: default|error|success. Hỗ trợ leftIcon/rightIcon (component).
 */
export const Input = forwardRef(function Input(
  { className, leftIcon: LeftIcon, rightIcon: RightIcon, state = 'default', ...props },
  ref
) {
  const cls = cn(
    BASE,
    STATE[state] || STATE.default,
    'px-3 py-2.5',
    LeftIcon && 'pl-10',
    RightIcon && 'pr-10',
    className
  );
  // Ô giờ luôn là 24h: <input type="time"|"datetime-local"> hiển thị theo cài đặt vùng của
  // hệ điều hành (US → "02:30 PM"), nên chuyển sang component 24h dùng chung.
  const { type, ...rest } = props;
  let input;
  if (type === 'time') {
    input = <TimeInput24 ref={ref} className={cls} {...rest} />;
  } else if (type === 'datetime-local') {
    input = <DateTimeInput24 ref={ref} className={cls} {...rest} />;
  } else {
    input = <input ref={ref} type={type} className={cls} {...rest} />;
  }
  if (!LeftIcon && !RightIcon) return input;
  return (
    <div className="relative">
      {LeftIcon ? (
        <LeftIcon className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted" aria-hidden="true" />
      ) : null}
      {input}
      {RightIcon ? (
        <RightIcon className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted" aria-hidden="true" />
      ) : null}
    </div>
  );
});

export const Textarea = forwardRef(function Textarea({ className, state = 'default', rows = 4, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(BASE, STATE[state] || STATE.default, 'px-3 py-2.5 resize-y', className)}
      {...props}
    />
  );
});

export default Input;
